<template>
  <div id="sapp">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#sapp {
  width: 100%;
  height: 100%;
}
#nprogress .bar {
  background: purple !important;
}
</style>
